<template>
    <header class="main-header">
        <!-- Logo -->
        <a href="/" class="logo">
            <!-- mini logo for sidebar mini 50x50 pixels -->
            <span class="logo-mini"><b></b>ABFT</span>
            <!-- logo for regular state and mobile devices -->
            <span class="logo-lg"><b>Intranet</b> ABFT</span>
        </a>
        <nav class="navbar navbar-static-top" role="navigation">
            <!-- Sidebar toggle button-->

            <!--<a href="#" class="sidebar-toggle fa fa-refresh" role="button">-->
                <!--<span class="sr-only">Mettre à jour les routes</span>-->
            <!--</a>-->

            <!-- Navbar Right Menu -->
            <div class="navbar-custom-menu">
                <ul class="nav navbar-nav">

                    <!--<li class="dropdown messages-menu">-->
                        <!--<a href="#" @click.prevent="majRoutes()" v-if="getMainUser.isAdmin" class="dropdown-toggle">-->
                            <!--<i class="fa fa-refresh"></i>-->
                            <!--<span class="label label-success">4</span>-->
                        <!--</a>-->
                    <!--</li>-->

                    <!--<li class="dropdown messages-menu">-->
                        <!--<a href="#" @click.prevent="TestMultipleCalls()" class="dropdown-toggle">-->
                            <!--<i class="fa fa-bug"></i>-->
                            <!--&lt;!&ndash;<span class="label label-success">4</span>&ndash;&gt;-->
                        <!--</a>-->
                    <!--</li>-->
                    <!-- Messages: style can be found in dropdown.less-->
                    <!-- User Account Menu -->
                    <li class="dropdown user user-menu">
                        <!-- Menu Toggle Button -->
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                            <!-- The user image in the navbar-->
                            <img :src="this.getMainUser.avatar" class="user-image" alt="User Image">
                            <!-- hidden-xs hides the username on small devices so only the image appears. -->
                            <span class="hidden-xs">{{this.getMainUser.name}}</span>
                        </a>
                        <ul class="dropdown-menu">
                            <!-- The user image in the menu -->
                            <li class="user-header">
                                <img :src="this.getMainUser.avatar" class="img-circle" alt="User Image">
                                <p>
                                    {{ this.getMainUser.name }}
                                    <small v-if="this.getMainUser.last_logout!=null">Dernière visite le
                                        {{this.getMainUser.last_logout}}
                                    </small>
                                </p>
                            </li>
                            <!-- Menu Footer-->
                            <li class="user-footer">
                                <div class="pull-left">
                                  <router-link
                                    class="btn btn-default btn-flat"
                                    :to="{ name: 'Profil'}">
                                    Profil
                                  </router-link>

                                    <router-link
                                            v-if="getMainUser.isAdmin"
                                            class="btn btn-default btn-flat"
                                            :to="{ name: 'Administration'}">
                                        Administration
                                    </router-link>
                                </div>
                                <div class="pull-right">
                                    <a @click.prevent="logout()" class="btn btn-default btn-flat">Se déconnecter</a>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </nav>
    </header>
</template>

<script type="text/babel">
    import Auth from '@/auth'
    import {mapGetters, mapActions} from 'vuex'

    import searchGeneral from '../Communs/searchGeneral'

    export default {
        data() {
            return {
                // auth: this.$store.state.auth,
            }
        },
        computed: {
            ...mapGetters({
                getMainUser: 'getMainUser',
                getAuth: 'getAuth'
            })
        },
        components: {
            searchGeneral
        },
        mounted() {
          //majRoutes
          // this.majRoutes()
          // console.log("majRoutes")
        },
        methods: {
            ...mapActions({
                setRoutes: 'setRoutes'
            }),
            // majRoutes: function () {
            //     let these = this
            //     if (this.getAuth.isLoggedIn)
            //         this.$http.get(process.env.API_URL + "/api/getAllRoutes").then((response) => {
            //                 these.setRoutes(response.body)
            //             }
            //         );
            // },
            TestMultipleCalls: function () {
                let these = this
                if (this.getAuth.isLoggedIn) {
                    this.$http.get(process.env.API_URL + "/api/ping").then((response) => {
                            these.$noty.success("Ping1: "+response.body)
                        }, (error => {
                            these.$noty.error("Erreur1")
                        })
                    );
                    this.$http.get(process.env.API_URL + "/api/ping").then((response) => {
                            these.$noty.success("Ping2: "+response.body)
                        }, (error => {
                            these.$noty.error("Erreur2")
                        })
                    );
                }

            },
            logout() {
                Auth.logout()
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Communs/navbar-header.vue